import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TableHeading } from '@components/Typography';
import { Button, Box } from '@components/common';
import AppActions, { AppSelectors } from '@redux/AppRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import BookingActions from '@redux/BookingRedux';
// import MoveOutModal from './MoveOutModal';

import history from '@utils/history';

function OtherInfo(props) {
  const {
    // showModal,
    setShowMoveOutModal,
    // initMoveOutBooking,
    // resetBooking,
    isPMUser
  } = props;
  // const handleShowModal = () => {
  //   setShowMoveOutModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowMoveOutModal(false);
  // };

  // const handleBookMoveOut = () => {
  //   initMoveOutBooking(true);
  //   history.push('/book');
  // };

  // const handleNormalBook = () => {
  //   resetBooking();
  //   history.push('/book');
  // };

  const handleViewSubscription = () => {
    history.push('/subscription');
  };

  useEffect(() => {
    return () => {
      setShowMoveOutModal(false);
    };
  }, [setShowMoveOutModal]);

  return (
    <React.Fragment>
      <TableHeading mb={4}>My Services</TableHeading>

      <Box display="flex" flexDirection="column" alignItems="flex-start">
        {!isPMUser && (
          <Button
            variant="secondary"
            mb={4}
            size={['medium', 'small']}
            onClick={handleViewSubscription}
          >
            Routine Services
          </Button>
        )}
        {/* {!isPMUser && (
          <Button
            variant="secondary"
            mb={4}
            size={['medium', 'small']}
            onClick={handleShowModal}
          >
            Book Move-Out Service
          </Button>
        )}
        <Button
          variant="secondary"
          mb={4}
          size={['medium', 'small']}
          onClick={handleNormalBook}
        >
          Book Service
        </Button> */}
      </Box>

      {/* <MoveOutModal
        show={showModal}
        onDismiss={handleCloseModal}
        onSubmit={handleBookMoveOut}
      /> */}
    </React.Fragment>
  );
}

OtherInfo.propTypes = {
  showModal: PropTypes.bool,
  setShowMoveOutModal: PropTypes.func,
  initMoveOutBooking: PropTypes.func,
  resetBooking: PropTypes.func,
  isPMUser: PropTypes.bool
};

const mapStatesToProps = state => ({
  showModal: AppSelectors.selectShowMoveOutModal(state),
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

const mapDispatchToProps = dispatch => ({
  setShowMoveOutModal: show => dispatch(AppActions.setShowMoveOutModal(show)),
  initMoveOutBooking: () => dispatch(BookingActions.initMoveOutBooking()),
  resetBooking: () => {
    dispatch(BookingActions.resetBooking());
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(OtherInfo);
